import React from "react";

export const PMReports = () => {
    return (
        <div className="flex items-center justify-center">
            <div>PM Report Coming soon...</div>
        </div>
    );
};